module.exports = __webpack_public_path__ + "media/images/bg_image/img_bg_image_peer_handshake-dc2c4131ecfc8fa01c17cbd3cdccbc3d.jpg";